"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_ICON_COLORS = exports.SOCIAL_PLATFORM_VALUES = void 0;
exports.SOCIAL_PLATFORM_VALUES = [
    "Facebook",
    "Instagram",
    "YouTube",
    "LinkedIn",
    "TikTok",
    "X",
    "Email",
    "Website",
    "Zeffy",
];
exports.SOCIAL_ICON_COLORS = ["Coloured", "White", "Black"];
